import { motion, useReducedMotion } from 'framer-motion';

const railMotion = {
    hidden: { opacity: 0, y: 96 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.85,
            ease: [0.22, 1, 0.36, 1],
        },
    },
};

export default function RightRail({ children }) {
    const shouldReduceMotion = useReducedMotion();

    return (
        <div className="page-right-shell">
            <motion.div
                className="page-right"
                initial={shouldReduceMotion ? false : 'hidden'}
                animate="visible"
                variants={shouldReduceMotion ? undefined : railMotion}
            >
                {children}
            </motion.div>
        </div>
    );
}
